import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCFYUSih8WQVQMS3NfFyO86I0xNe6jxavA",
    authDomain: "cinesageupdated.firebaseapp.com",
    databaseURL: "https://cinesageupdated-default-rtdb.firebaseio.com",
    projectId: "cinesageupdated",
    storageBucket: "cinesageupdated.appspot.com",
    messagingSenderId: "495019934904",
    appId: "1:495019934904:web:e2077b0ef1d7890d40204d"

};


// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth, getFirestore };